import React from "react";
import { Carousel } from "antd";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const imgData = [
  {
    uid: 1,
    url:
      "https://d1irs7zslorh1g.cloudfront.net/assets/slider/hands-cupping-heart-love-modified.jpg",
  },
  {
    uid: 2,
    url:
      "https://d1irs7zslorh1g.cloudfront.net/assets/slider/close-up-people-holding-apples-bag.jpg",
  },
  {
    uid: 3,
    url:
      "https://d1irs7zslorh1g.cloudfront.net/assets/slider/jungle_students.jpg",
  },
];

const DonationCarousel = ({ data = imgData }) => {
    console.log(data);
  
    return (
      <Carousel
        effect="fade"
        dotPosition="right"
        className="select-none"
        autoplay
        speed={1000}
      >
        {data.map((slide) => {
          console.log(`Slide URL: ${slide.url}`); // Log slide URL
          return (
            <div key={slide.url}>
              <div
                className="h-screen w-full bg-cover bg-center relative text-white"
                style={{
                  backgroundImage: `url(${slide.url})`,
                }}
              >
                {/* Overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-40"></div>
  
                {/* Content */}
                <div className="flex justify-center items-center h-full relative z-10">
                  {/* <h1 className="text-white text-4xl font-semibold">
                    Welcome to Our Platform
                  </h1> */}
                </div>
              </div>
            </div>
          );
        })}
      </Carousel>
    );
  };
  

export default DonationCarousel;
